import type { BatchHistoryEntry, BatchRow } from './types';

const KEY = 'repcheck:batches';
const MAX = 10;

function storage(): Storage | null {
	try {
		if (typeof localStorage === 'undefined') return null;
		return localStorage;
	} catch {
		return null;
	}
}

export function loadBatches(): BatchHistoryEntry[] {
	const store = storage();
	if (!store) return [];
	try {
		const parsed = JSON.parse(store.getItem(KEY) ?? '[]');
		return Array.isArray(parsed) ? parsed.filter(isEntry) : [];
	} catch {
		return [];
	}
}

function isEntry(v: unknown): v is BatchHistoryEntry {
	if (!v || typeof v !== 'object') return false;
	const e = v as Partial<BatchHistoryEntry>;
	return typeof e.id === 'string' && typeof e.signature === 'string' && Array.isArray(e.files);
}

export function findPreviousBatch(signature: string): BatchHistoryEntry | null {
	return loadBatches().find((b) => b.signature === signature) ?? null;
}

export function saveBatch(signature: string, rows: BatchRow[]): BatchHistoryEntry | null {
	const store = storage();
	if (!store) return null;
	const entry: BatchHistoryEntry = {
		id: `B-${Date.now().toString(36)}`,
		date: new Date().toISOString(),
		signature,
		files: rows.map((r) => ({ fileName: r.fileName, score: r.score, grade: r.grade }))
	};
	try {
		const list = [entry, ...loadBatches().filter((b) => b.signature !== signature)].slice(0, MAX);
		store.setItem(KEY, JSON.stringify(list));
		return entry;
	} catch {
		return null;
	}
}
